import {Injectable, isDevMode} from '@angular/core';

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {ToastService} from '../services/toast.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationInterceptor implements HttpInterceptor {

  origin = '';
  pathname = '';

  constructor(private toastService: ToastService) {
  }

  private readonly errorMessages = {
    403: '403 Accès refusé',
    404: '404 Ressource introuvable',
    500: '500 Erreur serveur',
    default: 'Une erreur est survenue'
  };

  public intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const url = req.url.toLowerCase();

    if (!url.startsWith(environment.api.baseUrl)) {
      return next.handle(req);
    }

    return next
      .handle(req)
      .pipe(catchError((err) => {
          if (isDevMode()) {
            console.error('error', err);
          }
          if (err.status === 401) {
            sessionStorage.clear();
            this.origin = window.location.origin;
            if (window.location.pathname.replace(/\//g, "")!== ""){
              this.pathname = window.location.pathname;
            }
            window.location.href = environment.baseUrlBack + 'login?redirect=' + this.origin + this.pathname;
            return throwError(err.error.message);
          }
          let message = null;
          if (err.error) {
            message = err?.error?.message;
          }
          // ne toast pas les erreurs 400 et 422 car déjà traitées par les composants
          else if (err.status !== 400 && err.status !== 422) {
            message = this.findErrorMessage(err.status);
          }
          if (null !== message) {
            this.toastService.show(message, {classname: 'toast-error'});
          }
          return throwError(err);
        }
      ));

  }

  private findErrorMessage(status: number) {
    return status in this.errorMessages ? this.errorMessages[status] : this.errorMessages.default;
  }
}
